/*
 * VerificationFileFields Messages
 *
 * This contains all the text for the VerificationFileFields component.
 */

import { defineMessages } from 'react-intl';
export const scope = 'src.pages.VerificationsPage.VerificationFileFields';

export default defineMessages({
  uploadedOnLabel: {
    id: `${scope}.uploadedOnLabel`,
    defaultMessage: 'Uploaded on {date}',
  },
  startDateLabel: {
    id: `${scope}.startDateLabel`,
    defaultMessage: 'Start date',
  },
  expirationDateLabel: {
    id: `${scope}.expirationDateLabel`,
    defaultMessage: 'Expiration date',
  },
  declineButton: {
    id: `${scope}.declineButton`,
    defaultMessage: 'Decline',
  },
  approveButton: {
    id: `${scope}.approveButton`,
    defaultMessage: 'Approve',
  },
  approveConfirmMessage: {
    id: `${scope}.approveConfirmMessage`,
    defaultMessage: 'Are you sure you want to approve this File?',
  },
  cancelIdLabel: {
    id: `${scope}.cancelIdLabel`,
    defaultMessage: 'Cancel ID: {id}',
  },
  jobIdLabel: {
    id: `${scope}.jobIdLabel`,
    defaultMessage: 'Job ID: {id}',
  },
});
